import useCurrentCountry from './useCurrentCountry';
import { useDataSourceVersion } from './useDataSourceVersion';
import { sourceByRouteSlug } from 'utils/dataSources';

export default function useEndDate(source) {
    const country = useCurrentCountry();
    const versions = useDataSourceVersion();
    const versionKey = sourceByRouteSlug(source)?.versionResultKey;
    if (!versionKey) return null;
    const query = versions[versionKey];
    return query?.data?.countries?.[country?.text_id]?.end_date || null;
}
